import logo247UpTime from "../assets/247uptime-logo.svg";
function OrderSubscriptionHeader() {
  return (
    <div className="subscription-header">
      <img
        src={logo247UpTime}
        style={{width: "auto", height: "48px", margin: "28px 100px",cursor:"pointer"}}
        alt="247UpTime Logo"
        onClick={()=> {window.location.href = "/login"}}
      />

      <span>Machinery Management</span>
    </div>
  );
}
export default OrderSubscriptionHeader;


